import { useRoute } from "vue-router";
import { onMounted, reactive } from "vue";
export default {
  name: "Protocol",
  setup() {
    const route = useRoute();
    let data = reactive({
      url: ""
    });
    onMounted(() => {
      data.url = route.query.url;
    });
    return {
      data
    };
  }
};